import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import app from 'flarum/forum/app';

const OPTIONS = [
  { value: null,      icon: 'far fa-bell-slash', key: 'not_following' },
  { value: 'follow',  icon: 'fas fa-bell',       key: 'follow' },
  { value: 'ignore',  icon: 'fas fa-ban',        key: 'ignore' },
  { value: 'hide',    icon: 'fas fa-eye-slash',  key: 'hide' },
];

export default class EventSubscriptionButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }

  view() {
    const currentValue = app.session.user?.attribute('eventSubscription') ?? null;
    const current = OPTIONS.find((o) => o.value === currentValue) ?? OPTIONS[0];
    const t = (key) => app.translator.trans('florcarioca-rsvp.forum.event_subscription.' + key);

    return (
      <Dropdown
        buttonClassName="Button EventSubscriptionButton"
        label={<span><i className={current.icon + ' icon'}></i>{' '}{t(current.key)}</span>}
        loading={this.loading}
      >
        {OPTIONS.map((option) => (
          <Button
            className={'Button' + (current.value === option.value ? ' active' : '')}
            icon={option.icon}
            onclick={() => this.setSubscription(option.value)}
          >
            <span className="EventSubscriptionButton-content">
              <span className="EventSubscriptionButton-label">{t(option.key)}</span>
              <span className="EventSubscriptionButton-description">{t(option.key + '_description')}</span>
            </span>
          </Button>
        ))}
      </Dropdown>
    );
  }

  async setSubscription(value) {
    this.loading = true;
    m.redraw();

    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/event-subscription',
        body: {
          data: {
            attributes: { subscription: value },
          },
        },
      });

      if (app.session.user) {
        app.session.user.pushAttributes({ eventSubscription: value });
      }
    } catch (e) {
      app.alerts.show({ type: 'error' }, e.message || 'Une erreur est survenue');
    }

    this.loading = false;
    m.redraw();
  }
}
